/* jslint esversion: 6 */
export default {
  state: {
    uid: sessionStorage.getItem('modelView-uid') ? sessionStorage.getItem('modelView-uid') : '',
    snapshot: sessionStorage.getItem('modelView-2d-snapshot') ? sessionStorage.getItem('modelView-2d-snapshot') : '',
    modelViewSnapshot: sessionStorage.getItem('modelView-3d-snapshot') ? sessionStorage.getItem('modelView-3d-snapshot') : '',
    viewX: sessionStorage.getItem('modelView-x') ? sessionStorage.getItem('modelView-x') : '',
    viewY: sessionStorage.getItem('modelView-y') ? sessionStorage.getItem('modelView-y') : ''
  },
  mutations: {
    SET_MODELVIEW_UID(state, uid) {
      state.uid = uid;
      sessionStorage.setItem('modelView-uid', JSON.stringify(uid));
    },
    SET_MODELVIEW_SNAPSHOT(state, snapshot) {
      state.snapshot = snapshot;
      sessionStorage.setItem('modelView-2d-snapshot', JSON.stringify(snapshot));
    },
    SET_MODELVIEW_3D_SNAPSHOT(state, snapshot) {
      state.modelViewSnapshot = snapshot;
      sessionStorage.setItem('modelView-3d-snapshot', JSON.stringify(snapshot));
    },
    SET_MODELVIEW_X(state, viewX) {
      state.viewX = viewX;
      sessionStorage.setItem('modelView-x', JSON.stringify(viewX));
    },
    SET_MODELVIEW_Y(state, viewY) {
      state.viewY = viewY;
      sessionStorage.setItem('modelView-y', JSON.stringify(viewY));
    }
  },
  actions: {
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/modelview.js